import React, { useState } from 'react';
import { ProgressBar } from "@uppy/react";
import styles from './CustomUploadUppy.module.scss';
import Button from '../../bootstrap/Button.jsx';
import { FaIcon } from '../Icons.jsx';

function CustomUploadStatusBar ({uppy, editingFile, count, uploadComplete, cropperRef, editorOpts, show, autoUpload}) {
  const [uploading, setUploading] = useState(false);
  const currentFile = ()  => editingFile?.id ? uppy.getFile(editingFile?.id) : null;
  const [canAutoUpload, setCanAutoUpload] = useState(false);

  const upload = async () => {
    setUploading(true);
    await uppy.upload();
    setUploading(false);
  }

  const cancelEdit = () => {
    uppy.emit('file-editor:cancel', currentFile());
  }

  const clearAll = () => {
    uppy.removeFiles(uppy.getFiles().map(f => f.id));
  };

  const saveFile = async () => {
    const f = currentFile();
    if (!f || !cropperRef?.current) return;

    const canvas = cropperRef.current.getCroppedCanvas(editorOpts.cropper.croppedCanvasOptions);
    const blob = await new Promise(r => canvas.toBlob(r, f.type, 0.8));
    const fileLike = new File([blob], f.name, { type: blob.type || f.type });
    const canAutoUpload = autoUpload && f.type.startsWith('image/') && f.type !== 'image/svg+xml';
    setCanAutoUpload(canAutoUpload);

    uppy.setFileState(f.id, { data: fileLike, size: fileLike.size, type: fileLike.type });
    uppy.setFileMeta(f.id, { width: canvas.width, height: canvas.height });
    uppy.emit('file-editor:complete', uppy.getFile(f.id));
  }

  return (
    <>
      {show && <div className={`${styles['custom-image-uploader-bar']} uppy-DashboardContent-bar`}>
        {(uploadComplete || uploading || canAutoUpload)
        ? <div className={styles['upload-complete']}>{uploadComplete ?  'Upload complete' : `Uploading ${count} file${count === 1 ? '' : 's'}`}</div>
        : 
        <>
          {editingFile
            ? <Button size='sm' type='danger' onClick={cancelEdit}><FaIcon type='trash' />Delete</Button>
            : <Button size='sm' type='danger' onClick={clearAll}><FaIcon type='trash' />Delete</Button>
            }
          <div className='text-truncate' style={{fontSize: '0.9em', maxWidth: '35%'}}>
            {editingFile
              ? `Editing ${editingFile.name}`
              : `${count} file${count === 1 ? '' : 's'} selected`
            }
          </div>
          {editingFile
            ? <Button size='sm' onClick={saveFile}>Save</Button>
            : <Button size='sm' onClick={upload}><FaIcon type='upload' />Upload</Button>
            }
        </>}
      </div>}
      <ProgressBar uppy={uppy} hideAfterFinish={false} />
    </>
  )
}

export default CustomUploadStatusBar;